import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { YOUTUBE_URL, LINKEDIN_URL } from "@/data/content";

const EXPLORE = [
  { label: "How Work Actually Works", to: "/ideas", testId: "footer-link-ideas" },
  { label: "Learn", to: "/learn", testId: "footer-link-learn" },
  { label: "Consulting", to: "/consulting", testId: "footer-link-consulting" },
  { label: "Selected Work", to: "/work", testId: "footer-link-work" },
  { label: "About", to: "/about", testId: "footer-link-about" },
];

export default function Footer() {
  return (
    <footer className="border-t border-line/60 bg-charcoal/30" data-testid="site-footer">
      <div className="wrap grid gap-12 py-16 md:grid-cols-12 lg:py-20">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-6 max-w-sm text-lg font-medium tracking-tight text-slate-200">
            See how work actually works.
          </p>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-slate-500">
            Independent media, education and consulting about the hidden problems behind
            processes, people and technology.
          </p>
          <p className="mt-8 flex items-center gap-2.5 font-mono text-[10px] uppercase tracking-[0.28em] text-slate-600">
            <span className="animate-status inline-block h-1.5 w-1.5 rounded-full bg-glow" />
            System status — Operational
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="kicker !text-slate-500">Explore</p>
          <ul className="mt-5 space-y-3">
            {EXPLORE.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-sm text-slate-400 transition-colors duration-300 hover:text-glow"
                  data-testid={l.testId}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="kicker !text-slate-500">Connect</p>
          <ul className="mt-5 space-y-3">
            <li>
              <a
                href={YOUTUBE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-1.5 text-sm text-slate-400 transition-colors duration-300 hover:text-glow"
                data-testid="footer-link-youtube"
              >
                YouTube
                <ArrowUpRight size={13} className="text-slate-600 transition-colors group-hover:text-glow" />
              </a>
            </li>
            <li>
              <a
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-1.5 text-sm text-slate-400 transition-colors duration-300 hover:text-glow"
                data-testid="footer-link-linkedin"
              >
                LinkedIn
                <ArrowUpRight size={13} className="text-slate-600 transition-colors group-hover:text-glow" />
              </a>
            </li>
            <li>
              <Link
                to="/contact"
                className="text-sm text-slate-400 transition-colors duration-300 hover:text-glow"
                data-testid="footer-link-contact"
              >
                Start a conversation
              </Link>
            </li>
            <li>
              <Link
                to="/#fieldnotes"
                className="text-sm text-slate-400 transition-colors duration-300 hover:text-glow"
                data-testid="footer-link-fieldnotes"
              >
                Get the Fieldnotes
              </Link>
            </li>
            <li>
              <Link
                to="/privacy"
                className="text-sm text-slate-400 transition-colors duration-300 hover:text-glow"
                data-testid="footer-link-privacy"
              >
                Privacy
              </Link>
            </li>
            <li>
              <button
                onClick={() => {
                  localStorage.removeItem("or-consent");
                  window.location.reload();
                }}
                className="text-sm text-slate-400 transition-colors duration-300 hover:text-glow"
                data-testid="footer-cookie-preferences"
              >
                Cookie preferences
              </button>
            </li>
          </ul>
          <p className="mt-8 max-w-xs text-xs leading-relaxed text-slate-600">
            Fieldnotes emails and enquiries are stored securely, never shared, and only ever
            used to send what you asked for.
          </p>
        </div>
      </div>
      <div className="border-t border-line/50">
        <div className="wrap flex flex-col gap-2 py-6 font-mono text-[10px] uppercase tracking-[0.28em] text-slate-600 sm:flex-row sm:items-center sm:justify-between">
          <span>© 2026 Operating Reality</span>
          <span>operatingreality.co.uk</span>
        </div>
      </div>
    </footer>
  );
}
